export default {
  icons: {
    iconfont: 'fa',
    values: {
      plus: 'fas fa-plus',
      listening: 'fas fa-headphones',
      track: 'fas fa-cut',
      sound: 'fas fa-music',
      download: 'fas fa-file-download',
      delete: 'fas fa-trash',
      event: 'fas fa-calendar',
      undo: 'fas fa-undo',
      upload: 'fas fa-upload',
      check: 'fas fa-check',
    },
  },
} as any;
